module.exports = __webpack_public_path__ + "static/img/login_phone@3x.fe540a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_phone@3x.png
// module id = qsT5
// module chunks = 1